module.exports = __webpack_public_path__ + "static/media/takk.4a60b895.mp3";